import {PdsWidget} from './pds-widget';
import {ImageController} from './controllers/image-controller';
import {ImageOrientation} from './models/image-orientation';
import { PdsImage } from './interfaces/pds-image';
const HORIZONTAL_ORIENTATION_CLASS_NAME = 'user-avatar-horizontal-orientation';
const VERTICAL_ORIENTATION_CLASS_NAME = 'user-avatar-vertical-orientation';
const EVEN_ORIENTATION_CLASS_NAME = 'user-avatar-even';
const GRADIENT_SPECIFICATIONS_CLASS_NAMES = [
 'avatar-gradient-one',
 'avatar-gradient-two',
 'avatar-gradient-three',
 'avatar-gradient-four',
 'avatar-gradient-five',
 'avatar-gradient-six',
 'avatar-gradient-seven',
 'avatar-gradient-eight'
];
export class PdsUserAvatar extends PdsWidget {
  is: 'pds-user-avatar';
  avatar: PdsImage;
  imageController: ImageController;
  gradientConfig: string;
  useImage = true;
  properties = {
    avatar: {
      type: Object,
      observer: '_onObjectChange'
    }
  };

  _onObjectChange(): void {
    this.useImage = this.avatar.useImage;
    if (!this.useImage) {
      this.gradientConfig = GRADIENT_SPECIFICATIONS_CLASS_NAMES[Math.floor(Math.random() * GRADIENT_SPECIFICATIONS_CLASS_NAMES.length)];
      this.classList.add(this.gradientConfig);
    } else {
      this.imageController = new ImageController(this.avatar);
      this.imageController.getImageOrientation((imageOrientation: ImageOrientation) => {
        this.updateImageElementClass(imageOrientation);
      });
    }
  }

  updateImageElementClass(imageOrientation: ImageOrientation): void {
    let imgElement: HTMLElement | null = this.querySelector('img');
    if (imgElement != null) {
      switch (imageOrientation) {
        case 'HORIZONTAL':
         imgElement.classList.add(HORIZONTAL_ORIENTATION_CLASS_NAME);
         break;
        case 'VERTICAL':
          imgElement.classList.add(VERTICAL_ORIENTATION_CLASS_NAME);
          break;
        case 'EVEN':
          imgElement.classList.add(EVEN_ORIENTATION_CLASS_NAME);
          break;
        default:
      }
    }
  }

}
